const cCollapseSustainability = () => {
  const sustainabilityBlock = document.querySelector('.sustainability')
  const collapses = sustainabilityBlock?.querySelectorAll('.collapse')
  const imageContainer = sustainabilityBlock?.querySelector('.sustainability__thumb img')

    function changeActiveCollapse(collapse) {
      const image = collapse.parentElement.querySelector('.sustainability__img')?.src
  
      if (imageContainer && image) {
        imageContainer.setAttribute('src', image)
      }
  }

  if ( sustainabilityBlock !== null && collapses.length ) {
    collapses[0].querySelector('.collapse__header').click()
    changeActiveCollapse(collapses[0])

    collapses.forEach((collapse, index) => {
      const header = collapse.querySelector('.collapse__header')

      header.addEventListener('click', function () {
        changeActiveCollapse(collapse)
      })
    })
  }
}

export default cCollapseSustainability
